import { AuthoringBoundTextEditor } from "authoring/components/authoring-editor"

const MACRO_TOOLBAR_BUTTONS = [
    // Text formatting group
    "bold",
    "italic",
    "underline",
    "strikethrough",
    "|",
    // List and indent group
    "ul",
    "ol",
    "outdent",
    "indent",
    "|",
    // Insert group
    "link",
    "unlink",
    "table",
    "|",
    // History group
    "undo",
    "redo",
]

export function MacroContentEditor({ readOnly }) {
    return (
        <AuthoringBoundTextEditor
            field="content"
            label=""
            readOnly={readOnly}
            allBtns={MACRO_TOOLBAR_BUTTONS}
            simpleBtns={MACRO_TOOLBAR_BUTTONS}
        />
    )
}
